import React from 'react';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import { qsStringify } from '../../utilities/helper';
import Loader from '../common/Loader';
import Alert from 'react-bootstrap/Alert';
import DropdownButton from 'react-bootstrap/DropdownButton';
// import Dropdown from 'react-bootstrap/Dropdown';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button'

class ExpandedRow extends React.Component {

    hiddenRoles = ["HRExec", "HRElev"]

    constructor(props) {
        super(props);
        this.state = {
            newRoles: [],
            loadingRoles: true,
            selectedUserRoles: [],
            editingUser: false,
            selectedUser: {},
            errorMessage: "",
            showError: false,
            isChrome: true
        }
    }

    componentDidMount() {
        // //console.log(this.props);
        this.setState({ selectedUser: this.props.row });
        this.getUsersRoles(this.props.row.UserId);
        this.getGlobalRoles();
        this.getBrowserType()
    }

    getUsersRoles = (userId) => {
        this.setState({ loadingRoles: true });
        axios.get(process.env.REACT_APP_API_URL + "/api/user/roles/" + userId, AxiosConfig.configValue())
            .then(response => {
                // //console.log(response);
                let roles = response.data.roles.split(",");
                if (!response.data.roles) {
                    roles = [];
                }
                // //console.log("Parsed Roles", roles);
                this.setState({ loadingRoles: false, selectedUserRoles: roles.sort(), showError: false });
            })
            .catch(error => {
                this.setState({ showError: true, errorMessage: "Error getting users roles." })
                //console.log(error);
                AxiosConfig.handleError(error);
            })
            .finally(() => {
                this.setState({ loadingRoles: false });
            })
    }

    getGlobalRoles = () => {
        this.setState({ loadingRoles: true });
        axios.get(process.env.REACT_APP_API_URL + '/api/portal/role/*', AxiosConfig.configValue())
            .then(res => {
                // this.setState({ roles: res.data });
                // this.hideRoles(res.data)
                this.setState({roles: this.sortRoles(this.hideRoles(res.data))})
            })
            .catch(err => {
                //console.log(err);
                // alert("There was an error recieving roles from api.");
                AxiosConfig.handleError(err);
            })
            .finally(() => this.setState({ loadingRoles: false }));
    }

    hideRoles = (roles) => {
        let temp = []
        for(let i = 0; i < roles.length; i++){
            if(this.hiddenRoles.indexOf(roles[i].RoleName) === -1){
                temp.push(roles[i])
            }
        }
        return temp
    }

    sortRoles = (roles) => {
        return roles.sort((a, b) => (a.RoleName > b.RoleName) ? 1 : -1)
    }

    removeRole = (RoleName) => {
        // //console.log(RoleName);
        this.setState({ editingUser: true, loadingRoles: true });
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("authorization", AxiosConfig.configValue().headers.authorization);

        let urlencoded = new URLSearchParams();
        urlencoded.append("roleName", RoleName);
        urlencoded.append("userid", this.state.selectedUser.UserId);

        const requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: urlencoded,
        };

        fetch(process.env.REACT_APP_API_URL + "/api/user/roles", requestOptions)
            .then(response => {
                let final = this.state.selectedUserRoles;
                final.splice(final.indexOf(RoleName), 1);
                this.setState({ editingUser: false, selectedUserRoles: final, showError: false, loadingRoles: false, newRoles: [] });
            })
            .catch(error => {
                //console.log(error);
                this.setState({
                    editingUser: false,
                    showError: true,
                    errorMessage: "Error removing role. Please try again."
                });
                AxiosConfig.handleError(error);
            });
    }

    addRoleToUser = (userId) => {
        if (this.state.newRoles.length > 0) {
            for (let i = 0; i < this.state.newRoles.length; i++) {
                //console.log(this.state.newRoles[i])
                const requestBody = {
                    "userId": userId,
                    "roleName": this.state.newRoles[i]
                };
                axios.post(process.env.REACT_APP_API_URL + "/api/user/roles", qsStringify(requestBody), AxiosConfig.configValue())
                    .then(response => {
                        this.getUsersRoles(userId);
                    })
                    .catch(error => {
                        //console.log(error);
                        this.setState({ showError: true, errorMessage: "Error adding roles to user. Please try again." });
                        AxiosConfig.handleError(error);
                    })
            }
            this.setState({ editingUser: false, newRoles: [] })
        }
    }


    getBrowserType = () => {
        if (navigator.userAgent.indexOf("Firefox") !== -1) {
            this.setState({ isChrome: false })
        }
    }

    handleRoleInput = (role) => {
        if (document.getElementById(role).checked) {
            document.getElementById(role).checked = false
            let temp = this.state.newRoles
            temp = temp.filter(e => e !== role);
            this.setState({ newRoles: temp })
        } else {
            document.getElementById(role).checked = true
            let temp = this.state.newRoles
            temp.push(role)
            this.setState({ newRoles: temp })
        }
    }

    render() {
        const { UserName, UserId } = this.props.row;
        const {
            loadingRoles,
            selectedUserRoles,
            roles,
            errorMessage,
            showError,
        } = this.state;
        if (loadingRoles) {
            return <Loader title={`Loading ${UserName}'s Roles...`} />;
        }

        return (
            <div className="d-flex flex-column w-100 p-0 m-0">
                {
                    showError &&
                    <Alert dismissible={true} variant="danger" onClose={() => this.setState({ showError: false })}>
                        {errorMessage}
                    </Alert>
                }
                <div className="d-flex flex-column-reverse flex-md-row w-100 justify-content-between align-items-center">
                    <h5 className="text-center d-none d-md-block">{UserName} Roles:</h5>
                    <div className="d-flex flex-row flex-wrap w-100 align-items-center">
                        {
                            selectedUserRoles.length
                                ?
                                <div className="d-flex w-100 flex-row flex-wrap">
                                    {
                                        selectedUserRoles.map(role =>
                                            <Badge key={role} pill variant="primary" className="d-flex justify-content-between custom-pill">
                                                {role}
                                                <i className="material-icons pill-icon cursor-on-hover" onClick={() => this.removeRole(role)}>close</i>
                                            </Badge>
                                        )
                                    }
                                </div>
                                : "User has no roles"
                        }
                    </div>
                    {
                        roles &&
                        <DropdownButton title="Available Roles">
                            {
                                roles.map(role => {
                                    return (
                                        selectedUserRoles.includes(role.RoleName)
                                            ? null
                                            :
                                            <div className="custom-dropdown-item" key={role.RoleName} onClick={() => this.handleRoleInput(role.RoleName, UserId)}>
                                                {!this.state.isChrome && <input className="fox-radio" id={role.RoleName} type="radio" value={role.RoleName} name={role.RoleName} onChange={() => this.handleRoleInput(role.RoleName, UserId)} />}
                                                {this.state.isChrome && <input className="chrome-radio" id={role.RoleName} type="radio" value={role.RoleName} name={role.RoleName} onChange={() => this.handleRoleInput(role.RoleName, UserId)} />}
                                                <p>{role.RoleName}</p>
                                            </div>
                                    )
                                })
                            }
                            {
                                this.state.newRoles.length > 0 && <Button className="roles-save-btn" variant="primary" onClick={() => this.addRoleToUser(UserId)}>Save</Button>
                            }
                            {
                                roles.length === selectedUserRoles.length && <p id="no-roles-warning">No Roles</p>
                            }
                        </DropdownButton>
                    }
                    <h5 className="text-center d-block d-md-none">{UserName} Roles:</h5>
                </div>
            </div>
        );
    }
}

export default ExpandedRow;